import Product from 'src/app/model/product/product';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import { IPBoardHelper } from 'src/app/helpers/ip-board-helper';
import { Project } from 'src/app/model/project/project';
import ProjectHelper from 'src/app/helpers/project-helper';
import { ProductAssetsChangedEvent } from 'src/app/services/project-display-observable.service';
import { SubProject } from 'src/app/model/project/sub-project';
import { BaseProject } from 'src/app/model/project/base-project';
import { REGISTERED_ACTION_TYPES } from 'src/app/model/registered-action-type';
export class ClientBaseProjectSummaryHelper {
  private constructor() {}

  static verifyApproval(project: Project, subProject: SubProject): string {
    if (
      project.collaborative &&
      !ProjectHelper.multipleInvolvedCompanies(project)
    ) {
      return 'Er moeten meerdere klanten ingevuld worden voordat de opdracht kan goedgekeurd worden';
    }
    if (!ProjectHelper.hasApprovableAddress(subProject)) {
      return 'Er moet een adres ingevuld worden voordat de opdracht kan goedgekeurd worden';
    }
    return null;
  }

  static showWarningForApproval(products: Product[]): boolean {
    return (
      CollectionHelper.isPopulated(products) &&
      products.some(p => this.showApprovalWarningForProduct(p))
    );
  }

  private static showApprovalWarningForProduct(product: Product): boolean {
    if (product == null || !ProductHelper.isIPBoard(product)) {
      return false;
    }

    return (
      IPBoardHelper.needsExtraDesign(<IPBoard>product) &&
      (product.productAssets == null ||
        !product.productAssets.some(
          pa =>
            !pa.archived &&
            pa.formSection === IPBoardHelper.IMPRESSION_FORM_SECTION
        ))
    );
  }

  static shouldRecalculateExecutionAssets(
    productAssetsChangedEvent: ProductAssetsChangedEvent,
    products: Product[]
  ): boolean {
    if (!CollectionHelper.isPopulated(products)) {
      return false;
    }
    if (productAssetsChangedEvent.productId == null) {
      // in this case it concerns a project that hasn't been submitted yet, but the available information doesn't allow us
      // to determine which exact unsubmitted project, so return true if at least one product doesn't have an id just to be safe
      return products.some(p => p.id == null);
    } else {
      return products.some(p => p.id === productAssetsChangedEvent.productId);
    }
  }

  static shouldShowActionButtons(
    baseProject: BaseProject,
    project: Project
  ): boolean {
    return (
      ClientBaseProjectSummaryHelper.calculateHasUnfinishedPrintWorkOrText(
        project
      ) ||
      !ClientBaseProjectSummaryHelper.calculateNeedsAppointment(baseProject)
    );
  }

  private static calculateHasUnfinishedPrintWorkOrText(
    project: Project
  ): boolean {
    if (!CollectionHelper.isPopulated(project.products)) {
      return false;
    }
    for (const product of project.products) {
      if (
        ProductHelper.isIPBoard(product) &&
        (product.needPrintwork || product.textPrintworkChecked)
      ) {
        if (!CollectionHelper.isPopulated(product.registeredActions)) {
          return true;
        }
        let seenPrintWork = false;
        let seenText = false;
        for (const registeredAction of product.registeredActions) {
          if (
            registeredAction.registeredAction != null &&
            registeredAction.registeredAction.type != null
          ) {
            seenPrintWork =
              seenPrintWork ||
              registeredAction.registeredAction.type.ordinal ===
                REGISTERED_ACTION_TYPES.REGISTER_IMMO_PRINT.ordinal;
            seenText =
              seenText ||
              registeredAction.registeredAction.type.ordinal ===
                REGISTERED_ACTION_TYPES.REGISTER_IMMO_TEXT.ordinal;
          }
          if (
            (!product.needPrintwork || seenPrintWork) &&
            (!product.textPrintworkChecked || seenText)
          ) {
            return false;
          }
        }
        if (
          (product.needPrintwork && !seenPrintWork) ||
          (product.textPrintworkChecked && !seenText)
        ) {
          return true;
        }
      }
    }
    return false;
  }

  private static calculateNeedsAppointment(baseProject: BaseProject): boolean {
    return (
      baseProject.approved &&
      (baseProject.projectPlacement.appointment ||
        baseProject.projectPlacement.collectKey) &&
      !baseProject.projectPlacement.appointmentReady
    );
  }
}
